@if (has_metrics()) {
  <div class="dashboard-container">
    @if (company_product_name()) {
      <div class="d-flex align-items-center mb-3">
        @if (company_product_logo()) {
          <img [src]="company_product_logo()" [alt]="company_product_name()" class="product-logo" />
        }
        <h3 class="subtitle mb-0">{{ company_product_name() }}</h3>
      </div>
    }

    @for (level of levels(); track level.key) {
      <section class="metric-level-block">
        <div class="metric-level-header">
          <span class="metric-level-pill">{{ level.title }}</span>
        </div>

        @for (section of level.sections; track section.id) {
          <div class="metric-section-block">
            @if (section.title) {
              <div class="section-header mb-3">
                <h3 class="section-title subtitle text-uppercase fw-bold text-dark">
                  {{ section.title }}
                </h3>
              </div>
            }
            <div class="row g-3">
              @for (metric of section.company_metrics; track metric.id) {
                <div [class]="metric.bootstrap_class">
                  <app-company-metric-card [metric]="metric" (metric_updated)="onMetricUpdated()" />
                </div>
              }
            </div>
          </div>
        }
      </section>
    }
  </div>
} @else {
  <div class="dashboard-container">
    <div class="empty-state">
      <h3 class="subtitle mb-0">No hay datos disponibles</h3>
    </div>
  </div>
}
